// @ts-nocheck
/**
 * Size Chart Modal Component
 * Data source: window.trovelle.shop.metafields.custom.vendor_size_charts
 * Vendor: window.trovelle.product.vendor_handle
 */

class SizeChartModal {
  constructor() {
    this.modal = null;
    this.openBtn = null;
    this.isOpen = false;
    
    this.init();
  }

  init() {
    this.openBtn = document.querySelector('[data-size-chart-open]');
    
    if (!this.openBtn) return;

    // Get data from global object
    const trovelle = window.trovelle || {};
    const sizeCharts = trovelle.shop?.metafields?.custom?.vendor_size_charts;
    const product = trovelle.product;

    if (!sizeCharts) {
      this.openBtn.style.display = 'none';
      return;
    }

    // Create modal
    this.createModal();
    
    // Render chart
    this.renderChart(sizeCharts, product?.vendor);
    
    // Setup events
    this.setupEventListeners();
  }

  createModal() {
    const modalTitle = this.openBtn.dataset.modalTitle || 'Size Chart';
    const modalId = 'size-chart-modal-' + Date.now();

    const modalHTML = `
      <div 
        class="size-chart-modal" 
        id="${modalId}"
        role="dialog"
        aria-modal="true"
        aria-labelledby="${modalId}-title"
        data-size-chart-modal
        hidden
      >
        <div class="size-chart-modal__overlay" data-size-chart-close></div>
        <div class="size-chart-modal__container">
          <div class="size-chart-modal__header">
            <h2 id="${modalId}-title" class="size-chart-modal__title">${this.escapeHTML(modalTitle)}</h2>
            <button 
              type="button" 
              class="size-chart-modal__close"
              data-size-chart-close
              aria-label="Close size chart"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6L6 18"/>
                <path d="M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="size-chart-modal__content">
            <div class="size-chart-modal__loading">Loading size chart...</div>
          </div>
        </div>
      </div>
    `;

    // Append to body
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById(modalId);
  }

  setupEventListeners() {
    // Open button
    this.openBtn.addEventListener('click', () => this.open());

    // Close buttons
    const closeBtns = this.modal.querySelectorAll('[data-size-chart-close]');
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Focus trap
    this.modal.addEventListener('keydown', (e) => this.handleTabKey(e));
  }

  open() {
    this.modal.hidden = false;
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
    
    const closeBtn = this.modal.querySelector('.size-chart-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  close() {
    this.modal.hidden = true;
    this.isOpen = false;
    document.body.style.overflow = '';
    
    if (this.openBtn) this.openBtn.focus();
  }

  handleTabKey(e) {
    if (e.key !== 'Tab') return;

    const focusable = this.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /**
   * Render size chart from global data
   */
  renderChart(sizeCharts, vendorHandle) {
    const content = this.modal.querySelector('.size-chart-modal__content');
    if (!content) return;


    // Lookup vendor chart, fallback to default
    const chartData = sizeCharts[vendorHandle] || sizeCharts['default'];

    if (!chartData) {
      content.innerHTML = this.renderError('No size chart available for this vendor.');
      return;
    }

    content.innerHTML = this.buildChartHTML(chartData);
  }

  /**
   * Build HTML table from chart data
   */
  buildChartHTML(chartData) {
    let html = '';

    // Header title
    if (chartData.header) {
      html += `<h3 class="size-chart-modal__chart-title">${this.escapeHTML(chartData.header)}</h3>`;
    }

    // Build table
    html += '<div class="size-chart-modal__table-wrapper"><table class="size-chart-table">';

    // Table header
    html += '<thead><tr>';
    html += `<th>${this.escapeHTML(chartData.columns?.label || 'Measurement')}</th>`;
    
    if (chartData.columns?.headers) {
      chartData.columns.headers.forEach(header => {
        html += `<th>${this.escapeHTML(header)}</th>`;
      });
    }
    html += '</tr></thead>';

    // Table body
    html += '<tbody>';
    if (chartData.rows) {
      chartData.rows.forEach(row => {
        html += '<tr>';
        html += `<td><strong>${this.escapeHTML(row.label)}</strong></td>`;
        
        if (row.values) {
          row.values.forEach(value => {
            html += `<td>${this.escapeHTML(value)}</td>`;
          });
        }
        html += '</tr>';
      });
    }
    html += '</tbody></table></div>';

    // Footer
    if (chartData.footer) {
      html += `<p class="size-chart-modal__footer">${this.escapeHTML(chartData.footer)}</p>`;
    }

    return html;
  }

  renderError(message) {
    return `<p class="size-chart-modal__error">${this.escapeHTML(message)}</p>`;
  }

  escapeHTML(str) {
    if (typeof str !== 'string') return String(str);
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

/**
 * Initialize size chart
 */
function initSizeChart() {
  const wrapper = document.querySelector('[data-size-chart-wrapper]');
  
  if (wrapper && !wrapper.dataset.initialized) {
    wrapper.dataset.initialized = 'true';
    new SizeChartModal();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeChart);
} else {
  initSizeChart();
}

// Re-initialize on section reload (Shopify theme editor)
document.addEventListener('shopify:section:load', () => {
  initSizeChart();
});

// Expose for testing
window.SizeChartModal = SizeChartModal;
window.initSizeChart = initSizeChart;
